(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Filters submit on change: the result set is the feedback. */
  (function () {
    const form = document.getElementById('il-filter');
    const wall = document.querySelector('[data-wall]');
    if (!form || !wall) return;

    /* Coming back to this page, the browser restores the select to what was last picked here,
       which is the order of the page that was left for: put back this page's own. */
    const sortList = document.querySelector('select[name="sort_by"]');
    addEventListener('pageshow', () => {
      if (sortList) [...sortList.options].forEach((option) => { option.selected = option.defaultSelected; });
    });

    function apply() {
      const params = new URLSearchParams();
      const name = document.querySelector('[data-collection-name]')?.value.trim();
      if (name && /^[A-Za-z]{1,12}$/.test(name)) params.set('preview_name', name);
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((i) => params.append(i.name, i.value));
      form.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value !== '') params.set(i.name, i.value); });
      if (sortList && sortList.value) params.set('sort_by', sortList.value);
      location.search = params.toString();
    }
    form.addEventListener('change', apply);
    sortList?.addEventListener('change', apply);
    form.addEventListener('submit', (e) => { e.preventDefault(); apply(); });

    form.querySelectorAll('[data-more-options]').forEach((button) => {
      button.addEventListener('click', () => button.parentElement.removeAttribute('data-collapsed'));
    });

    /* Computer: Hide filters gives the grid the room. Phone: the Filter buttons open the panel. */
    const toggle = document.querySelector('[data-filters-toggle]');
    toggle?.addEventListener('click', () => {
      const hidden = wall.toggleAttribute('data-filters-hidden');
      toggle.querySelector('[data-filters-toggle-label]').textContent = hidden ? toggle.dataset.show : toggle.dataset.hide;
    });
    const panel = (open) => {
      wall.toggleAttribute('data-filters-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    document.querySelectorAll('[data-filters-open]').forEach((button) => {
      button.addEventListener('click', () => {
        panel(true);
        const group = button.dataset.filtersOpen && form.querySelector('[data-filter="' + button.dataset.filtersOpen + '"]');
        if (group) group.open = true;
      });
    });
    document.querySelector('[data-filters-close]')?.addEventListener('click', () => panel(false));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* The columns are open on a computer and fold away on a phone. */
  (function () {
    const phone = matchMedia('(max-width: 760px)');
    const set = () => document.querySelectorAll('.foot details').forEach((d) => { d.open = !phone.matches; });
    set();
    phone.addEventListener('change', set);
    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-cookie-preferences]');
      const banner = window.privacyBanner;
      if (!link || !banner || typeof banner.showPreferences !== 'function') return;
      event.preventDefault();
      try {
        Promise.resolve(banner.showPreferences()).catch(function () {
          window.location.assign(link.href);
        });
      } catch (_) {
        window.location.assign(link.href);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const menu = document.getElementById('il-menu');
    const burger = document.querySelector('[data-menu-open]');
    if (menu && burger) {
      let previousOverflow = '';
      const open = (on) => {
        if (on) menu.setAttribute('data-open', '');
        else menu.removeAttribute('data-open');
        burger.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on) previousOverflow = document.body.style.overflow;
        document.body.style.overflow = on ? 'hidden' : previousOverflow;
        (on ? menu.querySelector('[data-menu-close]') : burger).focus();
      };
      burger.addEventListener('click', () => open(!menu.hasAttribute('data-open')));
      menu.querySelector('[data-menu-close]').addEventListener('click', () => open(false));
      document.addEventListener('keydown', (e) => {
        if (!menu.hasAttribute('data-open')) return;
        if (e.key === 'Escape') open(false);
        if (e.key === 'Tab') {
          const focusable = [...menu.querySelectorAll('a[href], button:not([disabled]), select')];
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (e.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
        }
      });
      /* Widening past the breakpoint hides the panel by CSS, but the scroll lock has to be released too. */
      addEventListener('resize', () => {
        if (innerWidth > 760 && menu.hasAttribute('data-open')) open(false);
      });
    }

    /* The promise strip: the arrows step through the messages. */
    const promo = document.querySelector('[data-promo]');
    if (promo) {
      const messages = [...promo.querySelectorAll('.promo__msg')];
      let shown = 0;
      const show = (index) => {
        shown = (index + messages.length) % messages.length;
        messages.forEach((message, i) => { message.hidden = i !== shown; });
      };
      promo.querySelector('[data-promo-prev]').addEventListener('click', () => show(shown - 1));
      promo.querySelector('[data-promo-next]').addEventListener('click', () => show(shown + 1));
      if (messages.length < 2) promo.querySelectorAll('.promo__arrow').forEach((arrow) => { arrow.hidden = true; });
      show(0);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-more"]) return;
  try {
    
  /* The rail's hidden name field follows the page's. The hidden field is re-revealed by the card
     script, so it stays out of sight by its class. */
  (function () {
    const page = document.querySelector('[data-text-input][form="il-buy"]');
    const section = document.querySelector('.more-bands');
    if (!page || !section) return;
    const field = section.querySelector('[data-collection-name]');
    const head = section.querySelector('[data-more-head]');
    const plain = head.textContent;
    let timer;
    const follow = () => {
      const name = page.value.trim();
      if (field.value !== name) {
        field.value = name;
        field.dispatchEvent(new Event('input', {bubbles: true}));
      }
      head.textContent = /^[A-Za-z]{1,12}$/.test(name) ? head.dataset.template.replace('{name}', name) : plain;
    };
    page.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(follow, 600); });
    addEventListener('load', follow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const form = document.getElementById('il-buy');
    if (!form) return;

    const dataEl = document.querySelector('[data-variant-data]');
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const textInput = document.querySelector('[data-text-input][form="il-buy"]');

    function currentOptions() {
      const opts = [];
      form.querySelectorAll('[data-opt-position][aria-pressed="true"]').forEach((b) => {
        opts[parseInt(b.dataset.optPosition, 10) - 1] = b.dataset.optValue;
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find((v) => opts.every((val, i) => val === undefined || v.options[i] === val));
    }

    /* As Liquid writes prices (window.ilMoney, snippets/il-i18n.liquid). */
    function money(cents) {
      if (window.ilMoney) return window.ilMoney(cents);
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: form.dataset.currency || 'EUR',
      }).format(cents / 100);
    }

    /* Options drive the real variant, so the price, availability and what actually gets added to
       the cart all follow the choice that is pressed. */
    form.querySelectorAll('[data-opt-position]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.optPosition;
        form.querySelectorAll('[data-opt-position="' + pos + '"]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        const variant = matchVariant(currentOptions());
        if (!variant) return;
        form.querySelector('[data-variant-id]').value = variant.id;
        document.querySelectorAll('[data-price]').forEach((el) => { el.textContent = money(variant.price); });
        const onSale = variant.compare_at_price > variant.price;
        document.querySelectorAll('[data-was]').forEach((el) => {
          el.hidden = !onSale;
          el.querySelector('[data-was-amount]').textContent = onSale ? money(variant.compare_at_price) : '';
        });
        document.querySelectorAll('.add, .buybar button').forEach((b) => { b.disabled = !variant.available; });
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      });
    });

    /* The hero always shows the customer's model; examples have their own section. */
    const gallery = document.querySelector('[data-gallery]');
    if (gallery) {
      const preview = gallery.querySelector('[data-union-preview]');
      const decisions = form.querySelector('[data-product-decisions]');
      if (preview) {
        const syncState = () => { form.dataset.previewState = preview.dataset.state; };
        new MutationObserver(syncState).observe(preview, {attributes: true, attributeFilter: ['data-state']});
        syncState();
      }
      if (preview && decisions) {
        for (const selector of ['[data-preview-size]', '[data-preview-support]', '[data-product-note]']) {
          const node = preview.querySelector(selector);
          if (node) decisions.append(node);
        }
      }
      const kindLinks = [...document.querySelectorAll('[data-kind-link]')];
      const buybar = document.querySelector('[data-buybar-button]');
      function named() {
        const name = textInput ? textInput.value.trim() : '';
        /* The other two products open with the same name. */
        kindLinks.forEach((link) => {
          const url = new URL(link.href);
          if (/^[A-Za-z]{1,12}$/.test(name)) url.searchParams.set('preview_name', name);
          else url.searchParams.delete('preview_name');
          link.href = url.href;
        });
        if (buybar && !buybar.disabled) buybar.textContent = name || !textInput ? buybar.dataset.add : buybar.dataset.type;
        return name;
      }
      if (textInput) {
        textInput.addEventListener('input', () => {
          named();
          scheduleFit();
        });
        const phone = matchMedia('(max-width: 760px)');
        const viewport = window.visualViewport;
        const textStep = textInput.closest('[data-step="text"]');
        const heading = document.querySelector('.buy__head');
        const fold = gallery.closest('.fold');
        // Keep one product heading and one real form. On mobile they frame the full-width
        // stage from the start; decisions stay with the same form at every breakpoint.
        const headingHome = document.createComment('Product heading');
        const formHome = document.createComment('Product form');
        const status = preview?.querySelector('[data-preview-status]');
        heading?.before(headingHome);
        form.before(formHome);
        if (status && textStep) textStep.append(status);
        function layout() {
          if (!preview || !heading || !textStep) return;
          if (phone.matches) {
            fold.insertBefore(heading, gallery);
            (preview.querySelector('.ilup__detail') || preview.querySelector('[data-preview-gallery]')).after(form);
          } else {
            headingHome.after(heading);
            formHome.after(form);
          }
        }
        layout();
        let fitFrame = 0, blurTimer = 0;
        /* Fit the whole preview AND the field into the space above the keyboard. Scrolling the
           field alone leaves a full-height 4:5 stage above the visible screen. offsetTop also
           accounts for browsers that pan their visual viewport when the keyboard opens. */
        const fit = () => {
          fitFrame = 0;
          if (!phone.matches || document.activeElement !== textInput || !preview || !textStep) return;
          if (viewport && viewport.scale > 1.05) return; // Keep pinch zoom under the customer's control.
          const stage = preview.querySelector('.ilup__gallery:not([hidden]), .ilup__fallback:not([hidden])');
          if (!stage) return;
          const height = viewport?.height || innerHeight, top = viewport?.offsetTop || 0;
          const above = stage.getBoundingClientRect().top - heading.getBoundingClientRect().top;
          const below = textStep.getBoundingClientRect().bottom - stage.getBoundingClientRect().bottom;
          const stageHeight = Math.max(32, Math.min(360, Math.max(240, gallery.clientWidth * .72), height - above - below - 16));
          gallery.style.setProperty('--il-naming-stage-height', `${stageHeight}px`);
          gallery.toggleAttribute('data-preview-tight', stageHeight < 140);
          const shift = heading.getBoundingClientRect().top - top - 8;
          if (Math.abs(shift) > 1) window.scrollBy({top: shift, behavior: 'instant'});
        };
        function scheduleFit() {
          if (!fitFrame) fitFrame = requestAnimationFrame(fit);
        }
        function endNaming() {
          if (document.activeElement === textInput && phone.matches) return;
          const before = textInput.getBoundingClientRect().top;
          const wasNaming = document.body.classList.contains('il-naming');
          document.body.classList.remove('il-naming');
          gallery.style.removeProperty('--il-naming-stage-height');
          gallery.removeAttribute('data-preview-tight');
          // Restore the full product layout without moving the field or the button just tapped.
          if (wasNaming) window.scrollBy({top: textInput.getBoundingClientRect().top - before, behavior: 'instant'});
        }
        viewport?.addEventListener('resize', scheduleFit);
        viewport?.addEventListener('scroll', scheduleFit);
        window.addEventListener('resize', scheduleFit);
        phone.addEventListener('change', () => {
          layout();
          if (phone.matches && document.activeElement === textInput) startNaming();
          else endNaming();
        });
        function startNaming() {
          clearTimeout(blurTimer);
          if (!preview) return;

          if (phone.matches) {
            document.body.classList.add('il-naming');
            scheduleFit();
          }
        }
        // Loading, empty and invalid states can change the space below the stage.
        if (preview) new ResizeObserver(scheduleFit).observe(preview);
        textInput.addEventListener('focus', () => {
          startNaming();
        });
        /* A moment later: a tap on the button that took the focus still lands where it was aimed. */
        textInput.addEventListener('blur', () => { blurTimer = setTimeout(endNaming, 200); });
        textInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && phone.matches && preview && !event.isComposing) {
            event.preventDefault();
            textInput.blur();
          }
        });
      }
      named();
    }

    /* Phone: the pinned button goes once the page's own Add to Bag is on screen. Measured on scroll
       rather than with IntersectionObserver, which does not fire in a tab that is not compositing. */
    const bar = document.querySelector('[data-buybar]');
    const addBtn = form.querySelector('.add');
    if (bar && addBtn) {
      const sync = () => {
        const box = addBtn.getBoundingClientRect();
        bar.classList.toggle('away', box.top < innerHeight && box.bottom > 0);
      };
      addEventListener('scroll', sync, {passive: true});
      addEventListener('resize', sync);
      sync();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
